import { render } from "./statsMainPage.vue?vue&type=template&id=150a5728&scoped=true"
import script from "./statsMainPage.vue?vue&type=script&lang=js"
export * from "./statsMainPage.vue?vue&type=script&lang=js"

import "./statsMainPage.vue?vue&type=style&index=0&id=150a5728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150a5728"]])

export default __exports__